import { defineComponent as _defineComponent } from 'vue'
import { computed, ref, watch } from 'vue';
import { BModal } from 'bootstrap-vue';
import TemplateProductPodAssigner from '../TemplateProductPodAssigner/TemplateProductPodAssigner.vue';
import GenericPodAssigner from '../TemplateProductPodAssigner/GenericPodAssigner/GenericPodAssigner.vue';
import { PodAssignment, TemplateProduct } from '@/api/typings/templateProducts';
import { Provider } from '../../utils/PodProvider.enum';


export default /*#__PURE__*/_defineComponent({
  __name: 'TemplateProductPodAssignerModal',
  props: {
    templateProductId: { default: '' },
    podProvider: { default: '' },
    podName: { default: '' },
    value: { type: Boolean }
  },
  emits: ["input", "save", "close"],
  setup(__props: any, { emit }: { emit: ({
    (event: 'input', value: boolean): void;
    (event: 'save', value: Record<string, unknown>): void;
    (event: 'close'): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { templateProductId: string, podProvider: string, podName: string, value?: boolean };





// Fix: Initialize isVisible based on the value prop
const isVisible = ref(props.value || false);

// Fix: Watch the value prop to update isVisible
watch(() => props.value, (newValue) => {
    isVisible.value = newValue || false;
});

watch(isVisible, () => {
    emit('input', isVisible.value);
});

const isManualAssignment = computed(() => {
    return (
        props.podProvider?.length &&
        ![Provider.PRINTIFY, Provider.PRINTFUL].includes(props.podProvider.toLowerCase() as Provider)
    );
});

const modalTitle = computed(() => {
    const baseStr = 'Products Assigner';
    return isManualAssignment ? `${props.podName} ${baseStr}` : `POD ${baseStr}`;
});

const closeModal = () => {
    isVisible.value = false;
};

const onClose = () => {
    emit('close');
};

const onAssignment = (data: { templateProduct: TemplateProduct | null; podAssignment: PodAssignment[] }) => {
    emit('save', data);
};

return { __sfc: true,emit, props, isVisible, isManualAssignment, modalTitle, closeModal, onClose, onAssignment, BModal, TemplateProductPodAssigner, GenericPodAssigner }
}

})